import React from "react";

export const Footer = () => {
  return (
    <div className="footerHeight backgroundBlack">
      {/*<!-- ============  for  big  =============== -->*/}
      <div className="imges-section">
        <img
          className="img-fluid img-hide-do"
          src="/Images/logo-full-img.png"
          alt=""
        />
      </div>
      {/*<!-- ============  for  big end  =============== -->*/}

      {/*<!-- ============  for  small  =============== -->*/}
      <div className="app-links">
        <div className="tv-app">
          <p>TV App</p>
          <div className="icons">
            <a
              target="_blank"
              href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.watcho_multi&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921629696%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=HWc2lqNoCI%2Bcc8Z%2B%2BPiJPZv4geUGUgdl4afUWrzIYyM%3D&reserved=0"
              rel="noopener noreferrer"
            >
              <img src="/Images/image 91.png" alt="Android TV" />
            </a>
            <a
              target="_blank"
              href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.amazon.in%2FWatcho-Original-Spotlight-Exclusive-Shows%2Fdp%2FB07XPG5FW5&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7Ca2f0a735c90c41f989a008dce75865ed%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638639614099960778%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=qUFxHyACDUi0X8bR2kyd93%2Bp29MYaSwFAFIoncjq1to%3D&reserved=0"
              rel="noopener noreferrer"
            >
              <img src="/Images/image 75.png" alt="Amazon Fire TV" />
            </a>
            <a
              target="_blank"
              href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fapps.apple.com%2Fin%2Fapp%2Fwatcho-new-web-series-livetv%2Fid1440733653%3Fplatform%3DappleTV&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921647310%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=k9hbgGbarb8nkl9cpto5zL6tFyKH3OwNhpMXAh60rI4%3D&reserved=0"
              rel="noopener noreferrer"
            >
              <img
                src="/Images/Apple_T.png"
                alt="Apple TV"
                style={{ height: "28px", objectFit: "contain" }}
              />
            </a>
            <a
              target="_blank"
              href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.amazon.in%2FWatcho-Original-Spotlight-Exclusive-Shows%2Fdp%2FB07XPG5FW5&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7Ca2f0a735c90c41f989a008dce75865ed%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638639614099960778%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=qUFxHyACDUi0X8bR2kyd93%2Bp29MYaSwFAFIoncjq1to%3D&reserved=0"
              rel="noopener noreferrer"
            >
              <img src="/Images/image 75.png" alt="Amazon Fire TV" />
            </a>
          </div>
        </div>
        <div className="mobile-app">
          <p>Mobile App</p>
          <div className="icons">
            <a
              target="_blank"
              href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fapps.apple.com%2Fin%2Fapp%2Fwatcho-new-web-series-livetv%2Fid1440733653%3Fplatform%3DappleTV&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921647310%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=k9hbgGbarb8nkl9cpto5zL6tFyKH3OwNhpMXAh60rI4%3D&reserved=0"
              rel="noopener noreferrer"
            >
              <img
                src="/Images/image 77.png"
                alt="iOS"
                style={{ height: "42px", objectFit: "contain" }}
              />
            </a>
            <a
              target="_blank"
              href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.watcho_multi&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921629696%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=HWc2lqNoCI%2Bcc8Z%2B%2BPiJPZv4geUGUgdl4afUWrzIYyM%3D&reserved=0"
              rel="noopener noreferrer"
            >
              <img src="/Images/image 78.png" alt="Android" />
            </a>
          </div>
        </div>
      </div>
      {/*<!-- ============  for  small END =============== -->*/}

      <footer className="footer-check-me">
        <div className="footer-content">
          <a
            href="https://www.vzy.one/en/supportPage/termsOfUse"
            className="footer-link"
            target="_blank"
          >
            Terms & Condition
          </a>
          <a
            href="https://www.vzy.one/en/supportPage/privacyPolicy"
            className="footer-link"
            target="_blank"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.vzy.one/en/account"
            className="footer-link"
            target="_blank"
          >
            Help & Support
          </a>
        </div>
      </footer>
    </div>
  );
};
